import React, { useState } from 'react';
import GeneralForum from './GeneralForum';
import StateForums from './StateForums';
import './Master.css'; // Updated import

const Forums = () => {
  const [activeTab, setActiveTab] = useState('GeneralForum');

  return (
    <div className="forums-container">
      <div className="messageboard-content">
        <div className="tabs">
          <button
            className={activeTab === 'GeneralForum' ? 'active-tab' : ''}
            onClick={() => setActiveTab('GeneralForum')}
          >
            USA Forum
          </button>
          <button
            className={activeTab === 'StateForums' ? 'active-tab' : ''}
            onClick={() => setActiveTab('StateForums')}
          >
            State Forums
          </button>
        </div>
        <div className="forum-content">
          {activeTab === 'GeneralForum' && <GeneralForum />}
          {activeTab === 'StateForums' && <StateForums />}
        </div>
      </div>
    </div>
  );
};

export default Forums;
